(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
(() => {
  const syncBeforeAfterSlider = (range) => {
    const wrapper = range.closest('.t4s-before-after');
    if (!wrapper) return;
    wrapper.style.setProperty('--ba-position', `${range.value}%`);
  };

  const initBeforeAfterSliders = (root) => {
    root.querySelectorAll('[data-before-after-range]').forEach((range) => {
      syncBeforeAfterSlider(range);
      if (range.dataset.baInit === 'true') return;
      range.dataset.baInit = 'true';
      range.addEventListener('input', () => syncBeforeAfterSlider(range));
      range.addEventListener('change', () => syncBeforeAfterSlider(range));
    });
  };

  const getVideoEmbedUrl = (videoUrl) => {
    try {
      const url = new URL(videoUrl, window.location.href);
      const host = url.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&playsinline=1&rel=0` : videoUrl;
      }
      if (host.includes('youtube.com')) {
        let id = url.searchParams.get('v');
        if (!id && url.pathname.includes('/shorts/')) id = url.pathname.split('/shorts/')[1].split('/')[0];
        if (!id && url.pathname.includes('/embed/')) id = url.pathname.split('/embed/')[1].split('/')[0];
        return id ? `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&playsinline=1&rel=0` : videoUrl;
      }
      if (host.includes('vimeo.com')) {
        const match = url.pathname.match(/\/(?:video\/)?(\d+)/);
        return match ? `https://player.vimeo.com/video/${match[1]}?autoplay=1` : videoUrl;
      }
      return videoUrl;
    } catch (error) {
      return videoUrl;
    }
  };

  const startVideoCard = (trigger) => {
    const videoUrl = trigger.dataset.videoUrl;
    if (!videoUrl || trigger.classList.contains('is-playing')) return;

    const player = trigger.querySelector('[data-video-card-player]');
    if (!player) return;

    const isMp4 = /\.mp4(?:$|\?)/i.test(videoUrl);
    const media = document.createElement(isMp4 ? 'video' : 'iframe');

    if (isMp4) {
      media.src = videoUrl;
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('preload', 'auto');
    } else {
      media.src = getVideoEmbedUrl(videoUrl);
      media.allow = 'autoplay; encrypted-media; picture-in-picture';
      media.allowFullscreen = true;
      media.title = trigger.getAttribute('aria-label') || 'Video';
    }

    player.replaceChildren(media);
    trigger.classList.add('is-playing');
    trigger.removeAttribute('role');
    trigger.removeAttribute('tabindex');

    if (isMp4) {
      const playPromise = media.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    }
  };

  const initVideoCards = (root) => {
    root.querySelectorAll('[data-video-card-trigger]').forEach((trigger) => {
      if (trigger.dataset.videoCardInit === 'true') return;
      trigger.dataset.videoCardInit = 'true';
      trigger.addEventListener('click', () => startVideoCard(trigger));
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        startVideoCard(trigger);
      });
    });
  };

  initBeforeAfterSliders(document);
  initVideoCards(document);
  document.addEventListener('shopify:section:load', (event) => {
    initBeforeAfterSliders(event.target);
    initVideoCards(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
